var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import AudioVideoSelector from "./selector/AudioVideoSelector";
import SmartClassicSelector from "./selector/SmartClassicSelector";
import DropDown from "./DropDown";
import PlayShuffleSelector from "./selector/PlayShuffleSelector";
import { messages } from "../messages";
var ListViewHeader = /** @class */ (function (_super) {
    __extends(ListViewHeader, _super);
    function ListViewHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListViewHeader.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "listview-header" },
            this.props.showAudioVideoSelector &&
                React.createElement("div", { className: "audio-video-selector" },
                    React.createElement(AudioVideoSelector, { onChanged: this.props.onContentTypeChange, selected: this.props.contentType, buttonStyle: this.props.buttonStyle })),
            this.props.showPlayShuffleSelector &&
                React.createElement("div", { className: "play-shuffle-selector" },
                    React.createElement(PlayShuffleSelector, { onChanged: function (option) { return _this.props.onPlayShuffleChange && _this.props.onPlayShuffleChange(option); }, selected: this.props.playShuffle, buttonStyle: this.props.buttonStyle })),
            Boolean(this.props.showDuration) && React.createElement("div", { className: "dropdown-container" },
                React.createElement(DropDown, { className: 'duration-dropdown', dataSource: [messages.Daily, messages.Weekly, messages.Monthly], valueExtractor: function (t) { return t; }, keyExtractor: function (t) { return t.toLowerCase(); }, onValueSelected: function (value) {
                        _this.props.onDurationhange && value && _this.props.onDurationhange(value.toLowerCase());
                    }, selected: this.props.duration || 'monthly', selectText: messages.SelectADuration })),
            Boolean(this.props.showSortBy) && React.createElement("div", { className: "dropdown-container" },
                React.createElement(DropDown, { className: 'sortby-dropdown', dataSource: this.props.sortBys || [], keyExtractor: function (t) { return t.id.toString(); }, valueExtractor: function (t) { return t.name; }, onValueSelected: function (value) {
                        _this.props.onSortByChange && _this.props.onSortByChange(value);
                    }, selected: this.props.sortBy, selectText: messages.Relevance })),
            this.props.extraInfoLeft && React.createElement("div", { className: "extra-info" }, this.props.extraInfoLeft),
            this.props.viewType && this.props.onViewTypeChange && React.createElement("div", { style: { marginLeft: 'auto', marginRight: '8px' } },
                React.createElement(SmartClassicSelector, { onChanged: this.props.onViewTypeChange, selected: this.props.viewType }))));
    };
    return ListViewHeader;
}(React.PureComponent));
export default ListViewHeader;
//# sourceMappingURL=ListViewHeader.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/ListViewHeader.js
// module id = 1285
// module chunks = 0